<template>
<div id="offmenu-am">

	<div class="secs">
		<div class="corset">

		<div class="sec1">
			<router-link to="/artists" v-if="false" @click.native="toggleOffCanvasMenuActive(0)" class="olink">Artists</router-link>
			<router-link to="/" @click.native="toggleOffCanvasMenuActive(0)" class="olink">News</router-link><br>
			<router-link to="/production" @click.native="toggleOffCanvasMenuActive(0)" class="olink">Production</router-link><br>
			<router-link to="/about-us" @click.native="toggleOffCanvasMenuActive(0)" class="olink">About us</router-link><br>
			<router-link to="/follow-us" @click.native="toggleOffCanvasMenuActive(0)" class="olink">Follow us</router-link><br>
			<router-link to="/package" @click.native="toggleOffCanvasMenuActive(0)" class="olink">Package</router-link><br>
			<router-link to="/contact" @click.native="toggleOffCanvasMenuActive(0)" class="olink">Contact</router-link>
		</div>

		<div class="sec2" v-if="showArtistCats">
			<div @click="setArtistCat('style')" class="olink" :class="{'router-link-exact-active':(artistCat=='style')}">Style</div><br>
			<div @click="setArtistCat('hair')" class="olink" :class="{'router-link-exact-active':(artistCat=='hair')}">Hair</div><br>
			<div @click="setArtistCat('makeup')" class="olink" :class="{'router-link-exact-active':(artistCat=='makeup')}">Makeup</div><br>
			<div @click="setArtistCat('artdirection')" class="olink" :class="{'router-link-exact-active':(artistCat=='artdirection')}">Art Direction</div><br>
			<div @click="setArtistCat('setdesign')" class="olink" :class="{'router-link-exact-active':(artistCat=='setdesign')}">Set Design</div><br>			
		</div>

		<div class="sec3" v-if="artistCat">
			<template v-for="(a,a_i) in cat_artists">
				<router-link :to="'/artist/'+a.slug" @click.native="toggleOffCanvasMenuActive(0)" class="olink">{{a.full_name}}</router-link><br v-if="( a_i + 1 ) != cat_artists.length">
			</template>			
		</div>

		</div>
	</div>

</div>
</template>
<script>
import helpers from '../.././helpers.js'
import mixins from '../.././mixins.js'

export default {
	
	mixins: [ mixins.generic ],
	
	components: {
		
	},

	data(){ return {
			
		showArtistCats: true,
		
		artistCat: undefined,

		all_artists: [],

	}},

	computed: {

		cat_artists(){

			var _this = this
			
			return this.all_artists.filter(function(a){
				
				if( a['subtype_'+_this.artistCat] == 1 ) return true

				return false
			})

		},

//----------------------------------------------------------------------------------------

	},

	methods: {

//----------------------------------------------------------------------------------------

		setArtistCat(cat){
			this.artistCat = cat
		},

//----------------------------------------------------------------------------------------

		getArtists() {

			var _this = this

			this.fetch('get_artists', {}, {
				onSuccess(output){

					if( !output || !output.data || !output.data.artists ) return

					_this.all_artists = output.data.artists

				},
				onError(error){
					
				},
			})

		},

//----------------------------------------------------------------------------------------

		toggleOffCanvasMenuActive(bool){
			if( bool == undefined ) bool = !this.$store.state.off_canvas_menu_active
			this.$store.commit('set_off_canvas_menu_active', bool )        
		},

//----------------------------------------------------------------------------------------

	},
	
	mounted(){
		
		this.getArtists()
		
	},

	watch: {
		
		

	},



}
</script>



// WEBPACK FOOTER //
// src/views/amanagement/AmHeaderMenu.vue